import { render, staticRenderFns } from "./npscard.vue?vue&type=template&id=5528b4b6&"
import script from "./npscard.vue?vue&type=script&lang=js&"
export * from "./npscard.vue?vue&type=script&lang=js&"
import style0 from "./npscard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports